var map = {
	"./routing/index.js": 1181,
	"./translation/index.js": 1182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;


//////////////////
// WEBPACK FOOTER
// ./src/app/runs index.js
// module id = 303
// module chunks = 0